import LeistungsseiteTemplate from "@/components/feature/LeistungsseiteTemplate";
import landwirtschaftAllesAusEinerHandAsset from "@/assets/landwirtschaft-alles-aus-einer-hand.png";
import landwirtschaftDachflaechenNutzenAsset from "@/assets/landwirtschaft-dachflaechen-nutzen.png";
import landwirtschaftEigenverbrauchHofAsset from "@/assets/landwirtschaft-eigenverbrauch-hof.png";
import landwirtschaftHeroBgAsset from "@/assets/landwirtschaft-hero-bg.png";
import landwirtschaftInteressierenPhotovoltaikAsset from "@/assets/landwirtschaft-interessieren-photovoltaik.png";
import landwirtschaftReferenzPhotovoltaikHofAsset from "@/assets/landwirtschaft-referenz-photovoltaik-hof.png";
import landwirtschaftStromSpeichernAbsichernAsset from "@/assets/landwirtschaft-strom-speichern-absichern.png";
import { allTestimonials } from "@/data/testimonials";
import Seo, { serviceSchema } from "@/components/feature/Seo";

export default function Landwirtschaft() {
  return (
    <>
      <Seo
        title="Für die Landwirtschaft | Zweering Elektrotechnik Emmerich am Rhein"
        description="Photovoltaik auf Scheunen- und Stalldächern, Eigenverbrauch am Hof, Speicher und Absicherung — aus einer Hand am Niederrhein."
        canonical="https://zweering.de/landwirtschaft"
        breadcrumbs={[{"name": "Startseite", "url": "https://zweering.de/"}, {"name": "Für wen", "url": "https://zweering.de/landwirtschaft"}, {"name": "Landwirtschaft", "url": "https://zweering.de/landwirtschaft"}]}
      />
      <LeistungsseiteTemplate
      label="FÜR WEN"
      title="FÜR DIE LANDWIRTSCHAFT"
      subline="Scheunen- und Stalldächer in Energie verwandeln — Photovoltaik und Energielösungen für landwirtschaftliche Betriebe in Emmerich am Rhein und Umgebung."
      heroImage={landwirtschaftHeroBgAsset}
      heroImageAlt="Landwirtschaftliches Scheunendach mit Photovoltaik in Emmerich am Rhein"
      leadText={
        <>
          Kaum jemand hat so viel ungenutzte Dachfläche wie ein landwirtschaftlicher
          Betrieb. Diese Flächen sind{" "}
          <span style={{ color: "#4CAF50" }}>ideale Energieerzeuger</span> — und Ihr Hof
          verbraucht oft genau dann Strom, wenn die Sonne scheint.
        </>
      }
      panels={[
        {
          title: "DACHFLÄCHEN NUTZEN",
          body: "Scheunen, Ställe, Hallen — große Dächer bieten Platz für leistungsstarke Photovoltaik.",
          ctaLabel: "Zur Photovoltaik →",
          ctaHref: "/photovoltaik",
          image: landwirtschaftDachflaechenNutzenAsset,
          imageAlt: "Große Photovoltaik-Anlage auf dem Dach einer landwirtschaftlichen Scheune",
        },
        {
          title: (
            <>
              <span style={{ color: "#4CAF50" }}>EIGENVERBRAUCH</span> AUF DEM HOF
            </>
          ),
          body: "Melktechnik, Kühlung, Lüftung, Maschinen — Ihr Betrieb verbraucht tagsüber viel Strom, den Sie selbst erzeugen können.",
          image: landwirtschaftEigenverbrauchHofAsset,
          imageAlt: "Photovoltaik-Anlage auf landwirtschaftlichem Scheunendach mit Wechselrichter für Eigenverbrauch",
        },
        {
          title: "STROM SPEICHERN & ABSICHERN",
          body: "Mit Speicher und Ersatzstrom bleibt Ihr Betrieb auch bei Netzausfall versorgt — wichtig für Tier und Technik.",
          ctaLabel: "Zum Stromspeicher →",
          ctaHref: "/stromspeicher",
          image: landwirtschaftStromSpeichernAbsichernAsset,
          imageAlt: "Photovoltaik-Anlage auf landwirtschaftlichem Dach mit Stromspeicher und Ersatzstrom",
        },
        {
          title: "ALLES AUS EINER HAND",
          body: "Planung, Installation und Betreuung vom Elektro-Meisterbetrieb — ein Ansprechpartner für Ihren Hof.",
          image: landwirtschaftAllesAusEinerHandAsset,
          imageAlt: "Photovoltaik auf landwirtschaftlichem Dach — Komplettleistung in Emmerich am Rhein",
        },
      ]}
      testimonials={allTestimonials}
      manifest={"Ihr Hof.\nIhre Fläche.\nIhre Energie."}
      caseStudy={{
        title: "PHOTOVOLTAIK AUF DEM HOF",
        text: "PV-Anlage auf landwirtschaftlichem Dach mit hohem Eigenverbrauch, installiert aus einer Hand in Emmerich am Rhein und Umgebung.",
        href: "/referenzen",
        linkLabel: "Mehr Referenzen",
        image: landwirtschaftReferenzPhotovoltaikHofAsset,
        imageAlt: "Landwirtschaftliche Scheune mit großer Photovoltaik-Anlage auf dem Dach",
      }}
      faq={[
        {
          frage: "Eignen sich Scheunen- und Stalldächer für Photovoltaik?",
          antwort:
            "Sehr gut. Große zusammenhängende Dachflächen sind ideal für leistungsstarke Anlagen. Wir prüfen Statik und Eignung Ihres Dachs.",
        },
        {
          frage: "Lohnt sich das für meinen Betrieb?",
          antwort:
            "Besonders, weil landwirtschaftliche Betriebe oft tagsüber viel Strom verbrauchen — genau dann, wenn die Anlage produziert.",
        },
        {
          frage: "Was passiert bei Stromausfall?",
          antwort:
            "Mit Speicher- und Notstromlösungen sichern wir kritische Bereiche wie Kühlung oder Lüftung ab. Welche Lösung passt, klären wir mit Ihnen.",
        },
        {
          frage: "Übernehmen Sie die komplette Umsetzung?",
          antwort:
            "Ja. Von der Beratung bis zur Betreuung — alles aus einer Hand vom Elektro-Meisterbetrieb.",
        },
      ]}
      ctaText={{
        headline: "IHRE DACHFLÄCHEN IN ENERGIE VERWANDELN?",
        subtext: "Kostenlose Beratung für landwirtschaftliche Betriebe.",
        buttonLabel: "Beratung anfragen",
        buttonHref: "/kontakt",
        variant: "green",
      }}
      crossLink={{
        title: "PHOTOVOLTAIK",
        text: "So funktioniert Ihre eigene Solaranlage.",
        href: "/photovoltaik",
        image: landwirtschaftInteressierenPhotovoltaikAsset,
        imageAlt: "Große Photovoltaik-Anlage auf Industriedach unter bewölktem Himmel",
      }}
    />
    </>
  );
}
